<template>
    <div class="wrapper-page product-show">
        <modal ref='productForm'>
            <template #header>
                <h5 class="modal-title mt-0">{{ $t('product_show.edit')}} {{ productInfo }}</h5>
            </template>

            <template #body>
                <form @submit.prevent="updateProduct($event)">
                    <div class="modal-body">
                        <div class="form-group">
                            <label class="col-form-label">
                                {{ userProductName }}
                            </label>

                            <input type="text" name="product[name]" class="form-control"
                                   required="required" :value='product.name'/>
                        </div>

                        <div class="form-group">
                            <label class="col-form-label">
                                {{ userProductCode}}
                            </label>

                            <input type="text" name="product[code]" class="form-control"
                                   :value='product.code'/>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <input type="submit" :value="$t('product_show.update')"
                               class="btn btn-primary float-right">
                    </div>
                </form>
            </template>
        </modal>

        <modal ref='archiveProduct'>
            <template #header>
                <h5 class="modal-title mt-0">{{ $t('product_show.edit')}} {{ productInfo }}</h5>
            </template>

            <template #body>
                <form @submit.prevent="updateProduct($event)">
                    <input type='hidden' name='product[archive]' :value='!product.archive'/>

                    <div class="modal-body">
                        <p v-if='product.archive'>
                            {{ $t('products.archive.unarchive_product', {name: product.name}) }}
                        </p>
                        <p v-else>
                            {{ $t('products.archive.archive_product', {name: product.name}) }}
                        </p>
                    </div>

                    <div class="modal-footer">
                        <input v-if='product.archive' type="submit"
                               :value="$t('products.archive.unarchive_product_button')"
                               class="btn btn-primary float-right">
                        <input v-else type="submit"
                               :value="$t('products.archive.archive_product_button')"
                               class="btn btn-primary float-right">
                    </div>
                </form>
            </template>
        </modal>

        <div class="container-fluid">
            <h1 class="page-title">
                {{ userProductTitle }}: {{productInfo}}
                <a href="#" class="edit" @click.prevent="$refs.productForm.open">
                    {{ $t('product_show.edit')}}
                </a>
            </h1>
            <div class="clearfix"></div>

            <button href="#" @click.prevent="$refs.archiveProduct.open"
                    class="float-right btn btn-outline-primary m-r-10">
                {{ product.archive ? $t('product_show.unarchive') : $t('product_show.archive')}}
            </button>


            <div class="tags-cont">
                <tag-manager resourceType="product" :resource='product'
                             v-on:reload-list="loadProduct()"></tag-manager>
                <div class="tag-dropdown-column">
                    <div class="existing-tags-wrapper" :class="tag.color"
                         v-for="tag in product.tags">
                        <div class="btn-group btn-group-toggle" data-toggle="buttons">
                            <label class="btn active">
                                <router-link :to="{name: 'tag', params: { id: tag.id }}">
                                    {{tag.name}}
                                </router-link>
                            </label>
                            <label class="btn" @click.prevent="removeConnectedTag(tag, product.id)">
                                <i class="fa fa-remove"></i>
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <h2>{{ $t('product_show.status') }}</h2>
            <div class="live-checklist-wrapper">
                <status :items-count="checklistItems" :completed-items-count="checkedItems"/>
            </div>

            <div v-if="contacts.length === 0" class="empty-list-wrapper">
                <img src="../assets/empty_states/checklist.png"/>
                <p>{{ $t('product_show.empty_1') }}</p>
                <p>{{ $t('product_show.empty_2') }}
                    <strong>{{ $t('product_show.empty_3') }}</strong> {{ $t('product_show.empty_4')
                    }}
                </p>
            </div>
            <div v-else class="contacts-product" v-for="(contact, index) in contacts" :key='index'>
                <contact-product-data ref="contactProductData" :contact="contact"
                                      :product="product"
                :resource="resourceType(contact)"/>
            </div>
        </div>
    </div>
</template>

<script>
  import _modal from "../components/_modal"
  import status from "../components/checklists/_status"
  import tag_manager from "../components/tags/_tags_manager"
  import contact_product_data from '../components/products/contact_product_data'

  export default {
    components: {
      'modal': _modal,
      'status': status,
      'tag-manager': tag_manager,
      'contact-product-data': contact_product_data
    },

    watch: {
      '$route.params.id': 'loadProduct'
    },

    created() {
      this.loadProduct()
      this.store.sendMetrics({name: 'product', params: this.$route.params, path: this.$route.fullPath})
    },
    computed: {
      product() {
        return this.state.product || {}
      },
      productStats() {
        if (this.stats.products) {
          return this.stats.products.find(p => p.id === this.product.id)
        } else {
          return {}
        }
      },
      contacts() {
        if (this.productStats) {
          return this.productStats.contacts || []
        } else {
          return []
        }
      },
      checklistItems() {
        return this.contacts.reduce((s, c) => s + c.total, 0)
      },
      checkedItems() {
        return this.contacts.reduce((s, c) => s + c.checked, 0)
      },

      productInfo() {
        if (this.product.code === null) {
          return `${this.product.name}`
        } else {
          return `${this.product.name} - ${this.product.code}`
        }
      }
    },
    methods: {
      loadProduct() {
        this.store.getProduct(this.$route.params.id)
        this.statStore.getProducts({'filters[id]': this.$route.params.id})
      },
      updateProduct(e) {
        this.store.updateProduct(this.product.id, new FormData(e.target)).then(() => {
          this.store.sendMetrics({name: 'update_product', params: this.$route.params, path: this.$route.fullPath})

          this.$refs.productForm.close()
          this.$refs.archiveProduct.close()
          this.loadProduct()
        })
      },
      removeConnectedTag(tag) {
        this.store.removeConnectedTag(tag.id, {product_id: this.product.id}).then(() => {
          this.store.sendMetrics({name: 'remove_tag_from_product', params: this.$route.params, path: this.$route.fullPath})
          this.loadProduct()
        })
      },
      resourceType(contact) {
        if (contact.id !== null) {
          return "contact"
        } else {
          return "user"
        }
      }
    }
  }
</script>

<style lang="sass">
    @import "../styles/products.sass"
    @import "../styles/checklists.sass"
</style>
